<template>
    <Primitive
        :as="as"
        :class="classes"
    >
        <div :class="element('main')">
            <slot />
        </div>

        <div
            v-if="slots.aside"
            :class="element('aside')"
        >
            <slot name="aside" />
        </div>
    </Primitive>
</template>

<script setup lang="ts">
import type { KSplitProps } from './types'
import useBem from '@yeeroen/use-bem'
import { Primitive } from 'reka-ui'

import { computed, useSlots } from 'vue'

defineOptions({ name: 'KSplit' })

const props = withDefaults(defineProps<KSplitProps>(), {
    as: 'div',
    asidePosition: 'end',
    align: 'center',
    stack: 'main-first',
    overlayWide: false,
    container: false,
})

defineSlots<{
    default?: () => unknown
    aside?: () => unknown
}>()

const slots = useSlots()

const { block, element, modifier } = useBem('k-split')

const classes = computed(() => block(
    modifier(`aside-${props.asidePosition}`),
    modifier(`align-${props.align}`),
    modifier(`stack-${props.stack}`),
    modifier('overlay-wide', props.stack === 'overlay' && props.overlayWide),
    modifier('no-aside', !slots.aside),
    modifier('container', props.container),
))
</script>

<style lang="scss">
@use './k-split.scss';
</style>
